import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { IGetBimehNamehShakhSalesDisplayQuery } from '../SakhsSalesBimehNameh/Queries/IGetBimehNamehShakhSalesDisplayQuery';
import { KhodroHttpGetService } from '../Services/KhodroHttpService';

const getPrintBimehNamehShakhsSalesDisplay = createAsyncThunk(
  'ShakhSalesBimehNamehPrint/getPrintBimehNamehShakhsSalesDisplay',
  async (query: IGetBimehNamehShakhSalesDisplayQuery) => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.GetPrintBimehNamehShakhsSalesDisplay}`,
      params: query,
    });
  }
);

export default getPrintBimehNamehShakhsSalesDisplay;
